import { EventSourceBase } from '@deqo/podopolis';
import { injectable } from 'inversify';
import { Point } from '../../platform/geom/Point';

export type ConfettiRound = [string, Point, Point];
export type ConfettiFountain = [Point, number];

export const ConfettiRound = {
    computeCount(fromOrVector, to?: Point) {
        const velocity = this.computeVelocity(fromOrVector, to);
        return Math.round(Math.round(velocity) * 3 / 7) * 7;
    },
    computeVelocity(fromOrVector: Point, to?: Point) {
        return !!to
            ? ConfettiRound.computeVelocity(to.subtract(fromOrVector))
            : 10 * Math.log(fromOrVector.length());
    },
};

@injectable()
export class ConfettiCannon extends EventSourceBase<{ fire: ConfettiRound, ignite: ConfettiFountain }> {

    public fire(round: ConfettiRound) {
        super.emit('fire', round);
    }

    public ignite(fountain: ConfettiFountain) {
        super.emit('ignite', fountain);
    }
}
